import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { style } from '../../utils/style.js';
import { Icon } from './Icon.js';
const iconBgStyles = {
    '': 'bg-main-divider group-data-secondary:bg-white/30',
    primary: 'bg-main-divider',
    secondary: 'bg-secondary-light',
    opacity: 'bg-white/30',
};
export const RoundedIcon = JSX(({ className, defaultIconSize = 44, iconBgVersion = 'primary', size, icon, ...rest }) => {
    const widthAndHeight = String(size?.width || defaultIconSize);
    return icon ? (_jsx("div", { style: {
            width: `${widthAndHeight}px`,
            height: `${widthAndHeight}px`,
        }, className: style('rounded-icon object-fit flex justify-center items-center', iconBgStyles[iconBgVersion], className), children: _jsx(Icon, { ...rest, width: "54%", height: "54%", name: icon }) })) : null;
});
//# sourceMappingURL=RoundedIcon.js.map